<script setup lang="ts">
import { PSidePanel, PSidePanelContent } from '@pokerly/ui';
import { useSessionPanelsStore } from '@/stores/session-panels.ts';
import SessionRoundCard from '@/views/app/session/_components/toolbar/rounds/SessionRoundCard.vue';
import { useRoundsStore } from '@/stores/rounds-store.ts';
import { PScrollArea } from '@/components/core/p-scroll-area';
import SessionRoundsPanelDefaultHeader from '@/views/app/session/_components/toolbar/rounds/SessionRoundsPanelDefaultHeader.vue';
import SessionRoundsPanelSearchHeader from '@/views/app/session/_components/toolbar/rounds/SessionRoundsPanelSearchHeader.vue';
import { computed, ref } from 'vue';
import { useSessionStore } from '@/stores/session.ts';

const sessionPanelsStore = useSessionPanelsStore();
const roundsStore = useRoundsStore();
const sessionStore = useSessionStore();
const isSearchActive = ref(false);

function onSearchClick() {
    isSearchActive.value = true;
}

function onCancelSearchClick() {
    isSearchActive.value = false;
    roundsStore.clearSearchResults();
}

const rounds = computed(() => {
    if (isSearchActive.value) {
        return roundsStore.roundsSearchResults;
    }
    return roundsStore.rounds;
});
</script>

<template>
    <PSidePanel v-model="sessionPanelsStore.roundsPanel" side="right" width="443px">
        <PSidePanelContent class="overflow-y-hidden">
            <SessionRoundsPanelSearchHeader v-if="isSearchActive" @cancelSearchClick="onCancelSearchClick" />
            <SessionRoundsPanelDefaultHeader v-else @searchClick="onSearchClick" />
            <div
                v-if="isSearchActive && roundsStore.roundsSearchResults.length === 0"
                class="w-full py-6 px-20 text-center"
            >
                <span class="font-medium leading-none text-black/40">
                    Try searching by issue number, title or description
                </span>
            </div>
            <PScrollArea class="h-[calc(100%-50px)]">
                <SessionRoundCard
                    v-for="round in rounds"
                    :key="round.id"
                    :round="round"
                    :active="sessionStore.roundId === round.id"
                />
            </PScrollArea>
        </PSidePanelContent>
    </PSidePanel>
</template>
